package com.milta.feature.imports.data.repository

import com.milta.feature.imports.data.remote.ImportPdfApi
import com.milta.feature.imports.data.remote.dto.toDomain
import com.milta.feature.imports.domain.entity.ImportPdfResult
import com.milta.feature.imports.domain.repository.ImportPdfRepository

class ImportPdfRepositoryImpl(private val api: ImportPdfApi) : ImportPdfRepository {
    override suspend fun extractDeliveriesFromPdf(fileBytes: ByteArray, fileName: String): ImportPdfResult =
        api.extractDeliveriesFromPdf(fileBytes, fileName).toDomain()
}
